import React, { Component } from 'react';
import axios from 'axios';
import config from 'react-global-configuration';
import { Card, Label, Input, Button } from 'reactstrap';
import CommonNavbar from './commonNavbar';
import jwt_decode from 'jwt-decode';

class AdminIssuerBanksView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bankDetails: {
        issuerBankDisplayName: '',
        issuerDefaultCashbackFlag: '',
        issuerMinEmiAmount: '',
        issuerTermsConditions: '',
      },
    };
  }

  componentDidMount() {
    this.fetchBankDetails();
  }

  fetchBankDetails = () => {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const bankId = this.props.match.params.id;

    axios
      .post(
        `${config.get('API_URL')}/brandemi/get-issuer-bank-details`,
        { id: bankId },
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
          this.setState({
            bankDetails: response.data,
            loading: false,
          });
      })
      .catch((error) => {
        console.error("Error fetching bank details:", error);
        this.setState({ loading: false });
      });
  };

  handlePreview = () => {
    const { bankDetails } = this.state;

    // Make the API call to fetch JSP
    axios.post(
      `${config.get("API_URL")}/brandemi/get-chargeslip`,
      {
        issuingBank: bankDetails.issuerBankDisplayName,
        termsConditions: bankDetails.issuerTermsConditions,
      },
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`,
          "Content-Type": "application/json"
        },
        responseType: 'blob'
      }
    )
    .then((response) => {
      // Create a blob URL from the JSP response
      const file = new Blob([response.data], { type: 'text/html' });
      const fileURL = URL.createObjectURL(file);

      // Open the JSP response in a new pop-up window
      const previewWindow = window.open(fileURL, "Preview", "width=800,height=600");

      if (!previewWindow) {
        alert("Pop-up blocked! Please allow pop-ups for this site.");
      }
    })
    .catch((error) => {
      console.error("Error fetching the preview:", error);
      alert("Failed to fetch the preview.");
    });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { loading, bankDetails } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">
          <div className="card-query-builder top-pad-5">
            <div className="col-md-12">
              <div className="card">
                <div className="header">
                  <h4 className="title pull-left">Bank Details</h4>
                  <Button
                    color="primary"
                    className="btn-capitalize pull-right"
                    onClick={this.goBack}
                  >
                    Go Back
                  </Button>

                  <Button
                    color="primary"
                    className="btn-capitalize pull-right"
                    onClick={this.handlePreview}
                    style={{ marginRight: "10px" }}
                  >
                    Preview
                  </Button>
                </div>

                <div className="content">
                  <div className="container-fluid">
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Issuer Bank Name</Label>
                        <Input
                          type="text"
                          value={bankDetails.issuerBankDisplayName}
                          disabled
                        />
                      </div>
                      <div className="col-md-6">
                        <Label>Cashback Flag</Label>
                        <Input
                          type="text"
                          value={bankDetails.issuerDefaultCashbackFlag}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Min EMI Amount</Label>
                        <Input
                            type="text"
                            value={bankDetails.issuerMinEmiAmount}
                            disabled
                        />
                      </div>

                      <div className="col-md-6">
                        <Label>T&C</Label>
                        <textarea
                            className="form-control"
                            value={bankDetails.issuerTermsConditions}
                            disabled
                            rows={5}
                            style={{width: "100%", resize: "vertical"}}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminIssuerBanksView;